import { useAuth } from "@/context/authContext";
import { api } from "@/utils/api";
import { useState } from "react";
import { toast } from "sonner";
import type { ApiErrorLog } from "@shared/types/models";

export const useErrorLogs = () => {
  const { dispatch } = useAuth();
  const [loading, setLoading] = useState<{
    logs: boolean;
    deleting: boolean;
  }>({
    logs: false,
    deleting: false,
  });

  const loadAllErrorLogs = async (
    setErrorLogs: (logs: ApiErrorLog[]) => void,
  ): Promise<void> => {
    try {
      setLoading((prev) => ({ ...prev, logs: true }));
      const response = await api(
        "/error-logs",
        { method: "GET" },
        dispatch,
      );
      setErrorLogs(response.errorLogs ?? []);
    } catch (error: any) {
      toast.error(error?.message ?? "Failed to load error logs");
    } finally {
      setLoading((prev) => ({ ...prev, logs: false }));
    }
  };

  const deleteErrorLog = async (id: string): Promise<boolean> => {
    try {
      setLoading((prev) => ({ ...prev, deleting: true }));
      await api(`/error-logs/${id}`, { method: "DELETE" }, dispatch);
      toast.success("Error log deleted");
      return true;
    } catch (error: any) {
      toast.error(error?.message ?? "Failed to delete error log");
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, deleting: false }));
    }
  };

  return { loading, loadAllErrorLogs, deleteErrorLog };
};
